{
  "signatureT": { "mk2": 1, "mk3": 2 }
}
